import smoothscroll from 'smoothscroll-polyfill';
import { closeMenu } from './layout';
import { handleOverlay } from './overlay';
smoothscroll.polyfill();

const header = document.getElementById('header');
const headerSubnav = header.querySelector('.sub-nav');

const scrollToSection = position => {
  window.scroll({
    top: position,
    left: 0,
    behavior: 'smooth'
  });
};

const getOffsetTop = elem => {
  let distance = 0;
  if (elem.offsetParent) {
    do {
      distance += elem.offsetTop;
      elem = elem.offsetParent;
    } while (elem);
  }
  return distance < 0 ? 0 : distance;
};

const scrollNavItems = Array.from(
  document.querySelectorAll('.scroll-link')
);
if (scrollNavItems.length) {
  const items = Array.from(scrollNavItems);
  for (let x = 0; x < items.length; x++) {
    const item = items[x];
    item.addEventListener('click', e => {
      e.preventDefault();
      const sectionID = item.getAttribute('href');
      const section = document.querySelector(sectionID);
      // gets header height
      let headerHeight = header.clientHeight;
      // if header subnav is hidden, predict its height (2.5 the font size)
      if (headerSubnav && isHidden(headerSubnav)) {
        // get elements styles
        const computedStyle = window.getComputedStyle(headerSubnav);
        // get font size, parse as integer
        const computedFontSize = parseInt(computedStyle.fontSize.replace('px', ''));
        // calculate height
        headerHeight += computedFontSize * 2.5;
      }
      scrollToSection(getOffsetTop(section) - headerHeight);
    });
  }

}


const scrollToTopButtons = document.querySelectorAll(
  '.back-to-top'
);
if (scrollToTopButtons) {
  for (let x = 0; x < scrollToTopButtons.length; x++) {
    const scrollToTopButton = scrollToTopButtons[x];
    scrollToTopButton.addEventListener('click', e => {
      e.preventDefault();
      scrollToSection(0);
    });
  }




}

const isHidden = (el) => {
  return (el.offsetParent === null)
  /*
  var style = window.getComputedStyle(el);
  return (style.display === 'none')
  */
}



const checkForHash = () => {
  if (window.location.hash) {
    // get hash
    var urlHash = window.location.hash;
    // if theres a hash,
    if (urlHash.length > 0) {
      // get element with same hash as ID
      const scrollableElement = document.querySelector(urlHash);
      if (scrollableElement) {
        setTimeout(function () {
          scrollToSection(getOffsetTop(scrollableElement) - header.offsetHeight);
          if( scrollableElement.hasAttribute('data-overlay-type') ){
            setTimeout(function () {
              handleOverlay(scrollableElement);
            }, 750);
          }
        }, 1000);
      }
    }
  }
}

checkForHash();

// header nav links with hash
const headerNavHashLink = Array.from(
  document.querySelectorAll('.header__nav-link[href*="/#"]')
);
if (headerNavHashLink.length) {
  const items = Array.from(headerNavHashLink);
  for (let x = 0; x < items.length; x++) {
    const item = items[x];
    item.addEventListener('click', e => {
      const sectionID = item.getAttribute('href').replace('/#', '#');
      const section = document.querySelector(sectionID);
      if (section) {
        console.log('section in page');
        // if section exists in page, scroll to it
        closeMenu();
        e.preventDefault();
        // gets header height
        let headerHeight = header.clientHeight;
        // if header subnav is hidden, predict its height (2.5 the font size)
        if (headerSubnav && isHidden(headerSubnav)) {
          // get elements styles
          const computedStyle = window.getComputedStyle(headerSubnav);
          // get font size, parse as integer
          const computedFontSize = parseInt(computedStyle.fontSize.replace('px', ''));
          // calculate height
          headerHeight += computedFontSize * 2.5;
        }
        scrollToSection(getOffsetTop(section) - headerHeight);
      }
    });
  }
}

export { checkForHash };

/*
const heroCtas = Array.from(
  document.querySelectorAll('.homepage-hero__scroll')
);
if (heroCtas.length) {
  for (let x = 0; x < heroCtas.length; x++) {
    const el = heroCtas[x];
    el.addEventListener('click', e => {
      e.preventDefault();
      var winHeight = window.innerHeight;
      scrollToSection(winHeight - 90);
    });
  }
}
*/